import moment from "moment";
import camelcaseKeys from "camelcase-keys";
import { removeDuplicates } from "./helper";
import _ from "lodash";
const DefaultColors = [
  "#D14040",
  "#7F40D1",
  "#2D76E5",
  "#1BBC86",
  "#E2E22D",
  "#92661A",
  "#EB9563",
  "#E5897F",
  "#E24E89",
  "#C063E8",
  "#63B3E8"
];

/** set/generate color */
const getRandomColor = () => {
  const letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

/** Key vlaue data */
const getKeyValueData = (data, configuration, withPercent) => {
  const resData = [];
  let totalCount = 0;
  const colors = [];

  if (configuration.isRepeated == true) {
    const filteredData = getAutoGenerateFilterData(
      data,
      configuration.autoGenerate
    );
    const b = {};
    totalCount = (filteredData || []).length;
    filteredData.forEach(el => {
      b[el[configuration.autoGenerate.key]] =
        (b[el[configuration.autoGenerate.key]] || 0) + 1;
    });

    Object.keys(b).map((key, ic) => {
      const color = DefaultColors[ic] || getRandomColor();
      colors.push(color);
      resData.push({ attributeName: key, attributeValue: b[key] });
    });
  } else {
    const columns = configuration.columns.sort(
      (a, b) => (a.sortOrder || 0) - (b.sortOrder || 0)
    );
    columns.map((item, ic) => {
      const filters = item.filters;
      let count = 0;
      const columnData = data || [];
      filters.forEach(element => {
        const result = columnData.filter(function(v) {
          return (
            v[element.key] != null &&
            v[element.key] != undefined &&
            v[element.key] ==
              element.values.find(value => value == v[element.key])
          );
        });
        count = count + (result || []).length;
      });
      totalCount += count;
      const color = item.color || (DefaultColors[ic] || getRandomColor());
      colors.push(color);
      resData.push({ attributeName: item.name, attributeValue: count });
    });
  }
  if (withPercent) {
    for (let i = 0; i < resData.length; i++) {
      resData[i].percentage = Math.round(
        (resData[i].attributeValue / totalCount) * 100
      );
    }
    return { data: resData, colors: colors };
  }
  return resData;
};

/** Download data */
const getDownloadData = (data, configuration) => {
  let resData = [];
  const columns = configuration.columns;

  if (configuration.isRepeated == true) {
    resData = getAutoGenerateFilterData(data, configuration.autoGenerate);
  } else {
    if (columns === undefined) return data || [];
    columns.map((item) => {
      const filters = item.filters;
      let columnData = data || [];
      filters.forEach(element => {
        const result = columnData.filter(function(v) {
          return (
            v[element.key] ==
            element.values.find(value => value == v[element.key])
          );
        });
        columnData = result;
      });
      resData = [...resData, ...columnData];
    });
  }
  return resData;
};

// const totalCount = (array, key) => {
//   return array.reduce((r, a) => {
//     return r + a[key];
//   }, 0);
// };

/** Get valid value */
const GetValidValue = (value, seriesItem, type) => {
  let isValid = false;
  switch (type) {
    case "Month":
    case "Week":
      if (moment(value).format("MM/DD/YY") == seriesItem.label) {
        isValid = true;
      }
      break;
    case "Day":
      //  object[type] = month.label;
      if (moment(value).format("H") == seriesItem.start) {
        isValid = true;
      }
      break;
    case "YTD":
      if (moment(value).format("MMM YY") == seriesItem.label) {
        isValid = true;
      }
      break;

    default:
      break;
  }
  return isValid;
};

/** Get chart data */
const getChartData = (
  data,
  configuration,
  startDate,
  endDate,
  type = "YTD",
  operation = "count"
) => {
  const columns = configuration.columns;
  const resData = [];
  type =
    moment(startDate).format("YYYY") === moment(endDate).format("YYYY") &&
    moment(startDate).format("MM") === moment(endDate).format("MM")
      ? "Month"
      : "YTD";

  const mainAccessor = getSeries(startDate, endDate, type);
  const CharAccessor = {};
  CharAccessor.mainAccessor = type;
  const colors = [];
  const barKeys = [];
  const barColors = [];
  const legends = [];
  if (configuration.isRepeated == true) {
    data = getAutoGenerateFilterData(data, configuration.autoGenerate) || [];
  }
  mainAccessor.map(month => {
    const object = {};

    object[type] = month.label;

    object.seriesItem = month;
    if (configuration.isRepeated == true) {
      const b = {};
      data.forEach(el => {
        const isValid = GetValidValue(
          el[configuration.trend.key],
          month,
          type,
          operation
        );
        if (operation == "Max") {
          if (isValid) {
            b[el[configuration.autoGenerate.key]] =
              (b[el[configuration.autoGenerate.key]] || 0) + 1;
          } else {
            b[el[configuration.autoGenerate.key]] =
              b[el[configuration.autoGenerate.key]] || 0;
          }
        } else {
          if (isValid) {
            b[el[configuration.autoGenerate.key]] =
              (b[el[configuration.autoGenerate.key]] || 0) + 1;
          } else {
            b[el[configuration.autoGenerate.key]] =
              b[el[configuration.autoGenerate.key]] || 0;
          }
        }
      });

      Object.keys(b).map((key, ic) => {
        CharAccessor["line" + ic] = key;
        const color = DefaultColors[ic] || getRandomColor();
        colors.push(color);
        if (barKeys.find(value => value == key) == undefined) {
          barColors.push(color);
          barKeys.push(key);
          legends.push({ label: key, color: color });
        }

        object[key] = b[key];
        colors[key] = color;
      });
    } else {
      columns.map((item, index) => {
        CharAccessor["line" + index] = item.name;

        const filters = item.filters;
        count = 0;
        const columnData = data || [];
        let filterResult = [...columnData];
        filters.forEach(element => {
          const result = filterResult.filter(function(v) {
            return (
              v[element.key] ==
              element.values.find(value => value == v[element.key])
            );
          });
          filterResult = [...result];
        });

        let count = filterResult.reduce((sum, currentValue) => {
          const isValid = GetValidValue(
            currentValue[configuration.trend.key],
            month,
            type
          );
          if (operation == "Max") {
            if (isValid) {
              return (sum || 0) > currentValue["Value"]
                ? sum
                : currentValue["Value"] || 0;
            } else {
              return sum;
            }
          } else {
            if (isValid) {
              return sum + 1;
            } else {
              return sum;
            }
          }
        }, 0);
        const color = item.color || (DefaultColors[index] || getRandomColor());
        if (barKeys.find(value => value == item.name) == undefined) {
          barColors.push(color);
          barKeys.push(item.name);
          legends.push({ label: item.name, color: color });
        }

        object[item.name] = count;
        colors[item.name] = color;
      });
    }
    resData.push(object);
  });
  return {
    chartAccessor: CharAccessor,
    data: resData,
    colors: colors,
    barKeys: barKeys,
    barColors: barColors,
    legends
  };
};

/** Auto generate filter data */
const getAutoGenerateFilterData = (data, autoGenerateConfig) => {
  let filteredData = (data || []).filter(x => {
    return (
      x[autoGenerateConfig.key] != undefined &&
      x[autoGenerateConfig.key] != null
    );
  });
  (autoGenerateConfig.filters || []).forEach(element => {
    const result = (filteredData || []).filter(function(v) {
      return (
        v[element.key] != null &&
        v[element.key] != undefined &&
        v[element.key] == element.values.find(value => value == v[element.key])
      );
    });
    filteredData = result;
  });
  return filteredData;
};

/** set startdate enddate values */
const getSeries = (startDateValue, endDateValue, type) => {
  const result = [];
  const startDate = moment(startDateValue);
  const endDate = moment(endDateValue);

  switch (type) {
    case "Month":
    case "Week":
      while (startDate.isBefore(endDate)) {
        result.push({
          label: startDate.format("MM/DD/YY"),
          start: startDate.startOf("day").format(),
          end: startDate.endOf("day").format()
        });
        startDate.add(1, "day");
      }
      result.push({
        label: endDate.format("MM/DD/YY"),
        start: endDate.startOf("day").format(),
        end: endDate.endOf("day").format()
      });
      break;

    case "Day":
      for (let i = 0; i < 24; i++) {
        result.push({
          label: (i > 10 ? i : "0" + i) + ":00",
          start: i,
          end: i + 1
        });
      }
      break;
    case "YTD":
      while (startDate.isBefore(endDate)) {
        result.push({
          label: startDate.format("MMM YY"),
          start: startDate.startOf("month").format(),
          end: startDate.endOf("month").format()
        });
        startDate.add(1, "month");
      }
      result.push({
        label: endDate.format("MMM YY"),
        start: endDate.startOf("month").format(),
        end: endDate.endOf("month").format()
      });
      break;

    default:
      break;
  }

  return removeDuplicates(result, "label");
};

/** Get props for data */
const getPropsForData = (type, responseData, widgetconfig, summaryData) => {
  // Change this function to change view data
  let data = [];
  let columns = [];
  if (type === "summary") {
    data = summaryData;
    if (widgetconfig.isConfigurable && widgetconfig.widgetType === 3) {
      let configuration = JSON.parse(
        JSON.stringify(widgetconfig.configuration)
      );
      configuration = camelcaseKeys(JSON.parse(configuration));
      columns = configuration.columns;
    }
  } else {
    if (
      widgetconfig.isConfigurable &&
      (widgetconfig.configuration || "") != ""
    ) {
      let configuration = JSON.parse(
        JSON.stringify(widgetconfig.configuration)
      );
      configuration = camelcaseKeys(JSON.parse(configuration));
      //columns = configuration.columns;
      data = getDownloadData(responseData, configuration);
    } else {
      data = responseData;
    }
  }

  if (columns.length === 0 && (data || []).length > 0) {
    Object.keys(data[0] || {}).map(key => {
      if (key != "seriesItem") {
        columns.push({ key: key, name: key });
      }
    });
  }

  return {
    data: data,
    columns: columns,
    config: {}
  };
};

/** get props for comparison data */
const getPropsForComparisonData = (
  comparisonLayouts,
  widgetconfig,
  renderChildTable,
  pageSize = 10
) => {
  const data = [];
  const columns = [];
  let isKeyValue = true;

  if (comparisonLayouts == undefined || comparisonLayouts.length <= 0) {
    return {
      data: data,
      columns: columns
    };
  }
  const accessor = comparisonLayouts[0].layoutComponent.accessor;
  const layoutComponent =
    (
      comparisonLayouts.filter(
        x => ((x.layoutComponent || {}).keys || []).length > 0
      )[0] || {}
    ).layoutComponent || {};
  const keys = layoutComponent.keys || [];
  let unit = layoutComponent.unit || "";
  if (unit == null || unit == "null") {
    unit = "";
  }
  isKeyValue = comparisonLayouts[0].layoutComponent.isKeyValue;

  if (isKeyValue == true) {
    columns.push({ key: "property", name: "Data center" });
    comparisonLayouts[0].layoutComponent.data.forEach(dataPoint => {
      columns.push({
        key: dataPoint["attributeName"],
        name: dataPoint["attributeName"]
      });
    });
  } else {
    columns.push({ key: accessor, name: "" });
    columns.push({
      key: "child",
      name: layoutComponent.xAxisLabel,
      renderComponent: renderChildTable
    });
  }
  if (isKeyValue == true) {
    comparisonLayouts.forEach(comObj => {
      const obj = {};
      obj.property = comObj.propertyName;
      comObj.layoutComponent.data.forEach(
        x => (obj[x["attributeName"]] = x["attributeValue"])
      );
      data.push(obj);
    });
  } else {
    comparisonLayouts[0].layoutComponent.data.forEach(dataPoint => {
      const obj = {};
      obj[accessor] = dataPoint[accessor];
      obj.child = "";
      data.push(obj);
    });
    const childColumn = [];

    childColumn.push({ key: "property", name: "Data center" });
    keys.forEach(key => {
      childColumn.push({
        key: key,
        name: key
      });
    });
    data.forEach(item => {
      const childData = [];
      (comparisonLayouts || []).forEach(comObj => {
        const obj = {};
        obj.property = comObj.propertyName;
        (keys || []).forEach(key => {
          obj[key] =
            (((((comObj || {}).layoutComponent || {}).data || []).find(
              x => x[accessor] == (item || {})[accessor]
            ) || {})[key] || 0) +
            " " +
            unit;
        });

        childData.push(obj);
      });
      item.child = {
        columns: [...childColumn],
        data: [...childData],
        config: { convertToNumber: true }
      };
    });
  }
  return {
    data: data,
    columns: columns,
    config: { pageSize: pageSize, convertToNumber: true }
  };
};

/** Y Axis labels */
const getYAxisLabel = (yAxisLabel, svg, y, x, angle) => {
  return svg
    .append("text")
    .attr("transform", "rotate(" + angle + ")")
    .attr("y", y)
    .attr("x", x)
    .attr("dy", "1em")
    .style("text-anchor", "middle")
    .style("font-family", "roboto")
    .style("font-size", "0.75em")
    .style("font-weight", "500")
    .style("fill", "#000000")
    .style("text-transform", "capitalize")
    .text(yAxisLabel || "count");
};

/** No data found Label */
const getNoDataFoundLabel = (range, svg, y, x) => {
  return (
    svg
      .append("g")
      .attr("transform", "translate(" + x + "," + y + ")")
      .append("text")
      // .attr("y", y)
      // .attr("x", x)

      .style("text-anchor", "middle")
      .style("font-family", "roboto")
      .style("font-size", "0.86em")
      .style("font-weight", "500")
      .style("fill", "#000000")
      .text(
        "No data available" +
          ((range || "") != "undefined to undefined" ? " for " + range : ".")
      )
  );
};

/** Chart dataset */
const getChartDataSet = (chartConfig, drillDownConfig, drillDownColumnsConfig) => {
  let startDateForTrend = chartConfig.startDate;
  let endDateForTrend = chartConfig.endDate;
  let typeForTrend = drillDownConfig.type;

  if (chartConfig?.configuration?.trend?.key &&
    chartConfig?.configuration?.trendOnPastDate === true ) {
    
      const dataList = _.orderBy(chartConfig.rawData,
      [data => (data[chartConfig?.configuration?.trend?.key] !== undefined && 
        moment(data[chartConfig?.configuration?.trend?.key]).format("MM/DD/YYYY") !== "Invalid date")
        ? (new Date(data[chartConfig?.configuration?.trend?.key])).getTime()
        : data[chartConfig?.configuration?.trend?.key]
      ],
      ["asc"]) || [];

      if(dataList.length > 0)
      {
        const minDate = moment(dataList[0][chartConfig?.configuration?.trend?.key]).startOf("month");
        const maxDate = moment(dataList[dataList.length - 1][chartConfig?.configuration?.trend?.key]).endOf("month");
        startDateForTrend = minDate.format("MM/DD/YYYY");
        endDateForTrend = maxDate.format("MM/DD/YYYY");

        if (maxDate.diff(minDate, "months", true) > 1) {
          typeForTrend = "YTD";
        }
        else {
          typeForTrend = "MTD";
        }
      }
  }

  const resData = getChartData(
    chartConfig.rawData,
    drillDownColumnsConfig,
    startDateForTrend,
    endDateForTrend,
    typeForTrend
  );
  return resData;
};

/** Rechart data */
const getRechartData = (
  data,
  configuration,
  rawData
) => {
  const columns = configuration.columns;
  const resData = [];
   data?.forEach(d => {
      const tempObj = {}
      if (resData.find(x => x[configuration.trend.key] === d[configuration.trend.key]) === undefined) {
        let totalCount = 0;
        columns.map(col => {
          let filteredData =  _.cloneDeep(rawData.filter(x => x[configuration.trend.key] === d[configuration.trend.key] && x[col.key] === col.value))
          if (configuration?.distinctOn) {
            filteredData = _.cloneDeep(getUniqueRecordFromProperty(filteredData, configuration?.distinctOn));
          }
          tempObj[col.value] = filteredData?.length || 0;
          totalCount += filteredData?.length || 0;
        })
        tempObj[configuration.trend.key] = d[configuration.trend.key];
        tempObj.totalCount = totalCount;
        resData.push(tempObj);
      }
   })
  
  return {
    data: resData
  };
};

/** Unique record from property by id/key */
function getUniqueRecordFromProperty (data, key) {
  const unique = [];
  (data || []).map(obj => {
    if (unique.find(y => y[key] === obj[key]) === undefined) {
      unique.push(obj);
    }
    return obj;
  })
  return unique;
}
export {
  getUniqueRecordFromProperty,
  getKeyValueData,
  getDownloadData,
  getPropsForData,
  getChartData,
  getYAxisLabel,
  getNoDataFoundLabel,
  getPropsForComparisonData as getPropsForComparisonData,
  getChartDataSet,
  getRechartData
};
